// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { CheckoutReviewAndSubmitPageContext } from "@insite/content-library/Pages/CheckoutReviewAndSubmitPage";
import { CheckoutShippingPageContext } from "@insite/content-library/Pages/CheckoutShippingPage";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { color } from "@rugby/XDL/Utilities";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = WidgetProps & {
    fields: {
        [fields.textFieldValue]: string;
    };
};
const enum fields {
    textFieldValue = "title",
}

export interface CheckoutShippingHeaderStyles {
    title?: InjectableCss;
}

const styles: CheckoutShippingHeaderStyles = {
    title: {
        css: css`
            border-top: 1px solid ${color("common.border")};
            color: ${color("text.main")};
            font-size: 28px;
            letter-spacing: 0;
            line-height: 32px;
            padding-top: 15px;
            margin-bottom: 40px;
        `,
    },
};

const CheckoutStepper: FC<Props> = ({ fields: { title } }) => {
    return <StyledWrapper {...styles.title}> {title}</StyledWrapper>;
};

const widgetModule: WidgetModule = {
    component: CheckoutStepper,
    definition: {
        displayName: "Checkout Custom Title",
        group: "Xngage Custom" as any,
        allowedContexts: [CheckoutShippingPageContext, CheckoutReviewAndSubmitPageContext],
        fieldDefinitions: [
            {
                name: fields.textFieldValue,
                displayName: "Text",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
